export const mailer = {
  name: 'mailer',
  title: 'mailer.breadcrumb.title',
  icon: () => import('@shared/components/icon/sidebar/icon-mailing.vue'),
  route: { name: 'mailer.mailing.index' },
  children: [
    {
      title: 'mailer.breadcrumb.mailing.create',
      route: { name: 'mailer.mailing.create' }
    },
    {
      title: 'mailer.breadcrumb.message.index',
      route: { name: 'mailer.message.index' },
      routes: [{ name: 'mailer.message.setting' }]
    },
    {
      title: 'mailer.breadcrumb.mailing.index',
      route: { name: 'mailer.mailing.type', params: { type: 'sms' } }
    },
    {
      title: 'mailer.breadcrumb.sender.index',
      route: { name: 'mailer.sender.index' }
    },
    {
      title: 'shared.breadcrumb.stats.title',
      route: { name: 'mailer.stats.type', params: { type: 'general' } }
    }
  ]
};
